/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Copiable } from "@Internal/Contracts";

import { BaseRole } from "Shared/Models";

/* Console role. Privileges are flat booleans (one per resource right); the UI groups them by
   resource and enforces the cascade (Create/Update imply Read). */
export default class Role extends BaseRole implements Copiable<Role> {
    static New( id: number = -1 ): Role {
        return new Role( id );
    }

    get Id(): number { return this.id; }

    Copy(): Role {
        const role = new Role( this.id, this.Name );

        role.Description = this.Description;
        role.IsProtected = this.IsProtected;
        role.CreatedBy = this.CreatedBy;
        role.UpdatedBy = this.UpdatedBy;
        role.CreatedAt = this.CreatedAt;
        role.UpdatedAt = this.UpdatedAt;

        role.PlanRead = this.PlanRead;
        role.PlanUpdate = this.PlanUpdate;
        role.CouponCreate = this.CouponCreate;
        role.CouponRead = this.CouponRead;
        role.CustomerCreate = this.CustomerCreate;
        role.CustomerRead = this.CustomerRead;
        role.AdsPublicationCreate = this.AdsPublicationCreate;
        role.AdsPublicationRead = this.AdsPublicationRead;

        return role;
    }
}
